import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setup" }
const _hoisted_2 = { class: "setup__bike" }
const _hoisted_3 = { class: "setup__content" }
const _hoisted_4 = { class: "setup__hardware" }

import {
  ButtonType,
  ButtonState,
  BfButton,
  BfInfoCard,
  ButtonIconPosition,
} from '@finetic/bikefitting-ui'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import { useI18n } from 'vue-i18n'
import TitleBar from '@/components/layout/TitleBar.vue'
import CurrentHardware from '@/components/setup/CurrentHardware.vue'
import BikeIllustration from '@/components/preview/common/BikeIllustration.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SetupView',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const measurementStore = useMeasurementStore()
const { firstMeasurement, selectedMeasurement } = storeToRefs(measurementStore)

const previous = () => {
  router.push({ name: 'start' })
}

const next = () => {
  if (!firstMeasurement.value.handlebar.active) {
    // When going to analysis-view (step 3) for first time, fill first measurement with current hardware.
    // Check if a handlebar (could also be saddle) has been selected. If not, add hardware.

    measurementStore.updateHardware(0, {
      crankset: {
        active: selectedMeasurement.value?.crankset.active,
      },
      handlebar: {
        active: selectedMeasurement.value?.handlebar.active,
      },
      saddle: {
        active: selectedMeasurement.value?.saddle.active,
      },
      pedal: {
        active: selectedMeasurement.value?.pedal.active,
      },
    })
  }

  router.push({ name: 'analysis' })
}

const hasHardwareSelected = computed(() => {
  return (
    selectedMeasurement.value.saddle.active &&
    selectedMeasurement.value.handlebar.active &&
    selectedMeasurement.value.crankset.active &&
    selectedMeasurement.value.pedal.active
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BikeIllustration)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TitleBar, {
        title: _unref(t)('setup.title')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BfButton), {
            type: _unref(ButtonType).Outlined,
            icon: "/icons/52-Arrows-Diagrams/01-Arrows/arrow-left-1.svg",
            onClick: previous
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.previous')), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          _createVNode(_unref(BfButton), {
            "icon-position": _unref(ButtonIconPosition).Right,
            state: 
            hasHardwareSelected.value ? _unref(ButtonState).Enabled : _unref(ButtonState).Disabled
          ,
            icon: "/icons/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg",
            onClick: next
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.next')), 1)
            ]),
            _: 1
          }, 8, ["icon-position", "state"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_unref(BfInfoCard), {
        title: _unref(t)('setup.hardware.notice.index')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('setup.hardware.notice.content')), 1)
        ]),
        _: 1
      }, 8, ["title"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CurrentHardware)
      ])
    ])
  ]))
}
}

})